<template>
  <div
    v-if="messageKey"
    class="wrong-login-text">
    <span>{{ getErrorMessage }}</span>
  </div>
</template>

<script>
import { mapState } from 'vuex';
const RATE_LIMIT_TIME = 15;

export default {
  name: 'LoginErrorMessage',
  computed: {
    ...mapState({
      messageKey: (state) => state.auth.loginError,
      userEmail: (state) => state.auth.userEmail,
    }),
    getErrorMessage() {
      switch (this.messageKey) {
        case 'sso-10':
        case 'sso-20':
        case 'sso-21':
        case 'sso-22':
        case 'sso-30':
        case 'sso-31':
        case 'sso-32':
          const errorCode = this.messageKey.match(/[^sso-](\d*)$/g)[0];
          return this.$gettextInterpolate(this.$gettext('Authentication error (code: %{ code })'), { code: errorCode });
        case 'wrongEmail':
          return this.$gettext(
            'This email may be incorrect. Make sure that you typed it correctly or contact your administrator.'
          );
        case 'wrongLogin':
          return this.$gettext('Wrong email or password');
        case 'wrongPassword':
          return this.$gettext('Wrong password');
        case 'wrong2faCode':
          return this.$gettext('Wrong authentication code');
        case 'wrongPin':
          return this.$gettext('Wrong PIN code');
        case 'cantLogin':
          return this.$gettext(
            'You are not allowed to log in to this account, please contact your Administrator for assistance.'
          );
        case 'wrongCredentials':
          return this.$gettextInterpolate(
            this.$gettext("%{ email } cannot access this share - it's locked to the designated recipient(s)."),
            { email: this.userEmail }
          );
        case 'captcha':
          return this.$gettext('reCAPTCHA verification failed');
        case 'rateLimit':
          return this.$gettextInterpolate(
            this.$ngettext(
              'Maximum login attempts exceeded. Please try again in %{ time } min.',
              'Maximum login attempts exceeded. Please try again in %{ time } mins.',
              RATE_LIMIT_TIME
            ),
            {
              time: RATE_LIMIT_TIME,
            }
          );
        case 'SSOonly':
          return this.$gettext('The login is restricted to SSO only');
        default:
          return '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wrong-login-text {
  color: $red;
  margin-bottom: 20px;
  text-align: center;
}
</style>
